// Availability and shipping wording. Change it here, not in components.
//
// Two different things, deliberately kept apart:
//   DISPATCH  - how long before the order leaves the supplier
//   DELIVERY  - how long the whole journey takes, door to door
// Do not merge them into a single figure. "2-4 days" is dispatch, not
// delivery, and presenting it as delivery would be a promise EFAM cannot keep.

export const EMS_STATUS = 'Available now';
export const DISPATCH_NOTE = 'Dispatched in 2-4 days';
export const DELIVERY_NOTE = 'Express worldwide, 2-4 weeks';
export const ACCESSORY_DELIVERY_NOTE = 'Express worldwide, 1-3 weeks';

// Machines and accessories: on sale today.
export const emsAvailability = {
  status: EMS_STATUS,
  dispatch: DISPATCH_NOTE,
  delivery: DELIVERY_NOTE,
  accessoryDelivery: ACCESSORY_DELIVERY_NOTE
};

// Red light: supplier discussions still open. No pricing, no purchase path,
// no availability date. Flip `forSale` only when TJ says the supplier is
// confirmed - and add real prices at the same time, never before.
export const redLightAvailability = {
  forSale: false,
  label: 'Coming soon',
  note: 'Not yet available to buy. We are still finalising suppliers, so no specifications or pricing are published yet.'
};
